import { Button, ButtonVariants } from '@comptia-sso/core';
import { ReactElement } from 'react';

// Styles.
import styles from './InstitutionHeader.module.scss';

export const InstitutionEditHeader = (): ReactElement => {
  return (
    <header className={styles.header}>
      <div className={styles.title}>
        <h1>Edit Institution</h1>
      </div>
      <div className={styles.breadcrumb}>
        <Button
          className={styles.back}
          link
          to="/consent-approvers"
          variant={ButtonVariants.Secondary}
        >
          Back to Institutions List
        </Button>
      </div>
    </header>
  );
};
